/**
 * Progressive MM/DD/YYYY masking for the additional-info form.
 *
 * Mirrors the behavior of `src/formatting/formatters/date-formatter.ts` so the
 * user experience matches the main form's DOB field, but lives inside the
 * additional-info module since the host is opted out of the global
 * format-engine (`data-no-format="true"` on the wrapper — required to keep
 * the bank/account/routing/license fields from being mangled by phone/SSN/
 * currency auto-detection).
 */

/**
 * Apply progressive MM/DD/YYYY masking to a raw input string.
 *
 *   '' → ''
 *   '1' → '1'
 *   '12' → '12'
 *   '123' → '12/3'
 *   '1234' → '12/34'
 *   '12345' → '12/34/5'
 *   '12345678' → '12/34/5678'
 *   '123456789' → '12/34/5678' (capped at 8 digits = MM/DD/YYYY)
 */
export function applyDateMask(raw: string): string {
  const digits = (raw || '').replace(/\D/g, '').substring(0, 8);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.substring(0, 2)}/${digits.substring(2)}`;
  return `${digits.substring(0, 2)}/${digits.substring(2, 4)}/${digits.substring(4)}`;
}
